[
  {
    "version": "1.3.0",
    "date": "2026-09-17",
    "title": "Team View Overhaul, Late-Entry Overrides & Full-Bleed Calendar",
    "changes": [
      "[Feature] Overhauled Team View with dual-mode layout: streamlined manager overview cards, admin search, and full-bleed calendar view.",
      "[Feature] Implemented late-entry override system allowing managers and admins to unlock past-cutoff trip logging with configurable expiration durations.",
      "[Fix] Automated monthly submission syncing on late-entry trip edits so submissions are automatically marked as Submitted and flagged for manager review.",
      "[UI] Full-bleed calendar layout eliminating vertical and horizontal window scrolling on desktop to enable smooth mousewheel month navigation.",
      "[Fix] Enabled interactive Changelog dialog on clicking the lower-corner version badge with hover styling matching TCH Bid Log."
    ],
    "userChanges": [
      "[Feature] Team View now features a dedicated full-window calendar and slide-out team member switcher.",
      "[Feature] Managers can now unlock late trip entry for team members when needed.",
      "[UI] Seamless calendar month navigation without window scrolling.",
      "[Fix] Clicking the version number in the bottom right corner now opens the App Version History dialog."
    ]
  },
  {
    "version": "1.2.1",
    "date": "2026-09-15",
    "title": "Monthly Cutoff Locking Defensive Validation & Enforcement",
    "changes": [
      "[Fix] Enforced monthly cutoff locking in TripService.saveTrip and deleteTrip to block late trip creation or modification.",
      "[Fix] Added dynamic date validation, locked banner, and datepicker filtering in TripDialogComponent to prevent selecting or saving locked dates.",
      "[Fix] Guarded calendar cell clicks in TripCalendarComponent to prevent opening new trip dialog for locked dates.",
      "[Fix] Resolved layout issue where navigation panel failed to adjust main content margins on initial login in full screen by adding autosize, synchronous breakpoint initialization, and animation complete callbacks."
    ],
    "userChanges": [
      "[Fix] Fixed an issue where trips could be entered for months that had already passed the monthly cutoff date.",
      "[Fix] Fixed an issue where the main page layout was partially obscured by the navigation menu upon logging in on desktop screens."
    ]
  },
  {
    "version": "1.2.0",
    "date": "2026-08-19",
    "title": "Modernization, Zoneless, OnPush, Self-Hosted Fonts & Security Hardening",
    "changes": [
      "[Feature] Added in-app Version History and Changelog dialog with category badges and role-based views, accessible by clicking the version number in the bottom right corner.",
      "[Security] Consolidated Firestore security rules and indexes into single source of truth in ../angular-bid-log, adding missing mileage composite indexes and pointing firebase.json configuration.",
      "[Security] Added HTTP security response headers to Firebase Hosting configuration (nosniff, HSTS, DENY frame, strict-origin, Permissions-Policy).",
      "[Security] Hardened Firestore security rules for trips and monthly submissions: locked approved trips from driver edits/deletions, restricted status transitions, and enabled server-side write confirmation.",
      "[Fix] Fixed previous-trip origin prefill query by adding monthKey equality filter matching deployed composite index and isolating lookup errors to ensure warehouse fallbacks execute.",
      "[Feature] Added dedicated Not-Authorized page with dashboard navigation for role-mismatched routes.",
      "[Refactor] Stripped debug console logging across guards, services, and dashboard.",
      "[Performance] Migrated remaining application templates from legacy structural directives (*ngIf, [ngClass]) to modern Angular control flow (@if, @for, @switch) and class bindings.",
      "[Performance] Optimized template evaluations by converting methods to computed signals and precomputing row-level statuses in approvals and frequent places.",
      "[Performance] Cleaned up observable subscriptions and migrated non-realtime queries (user list, team mileage aggregation) to one-shot Firestore getDocs reads.",
      "[Performance] Rolled out ChangeDetectionStrategy.OnPush across all 23 components in the application.",
      "[Performance] Switched to stable Zoneless change detection, eliminated Zone.js from the production bundle, and cleaned all NgZone wrappers.",
      "[Performance] Self-hosted all web fonts (Roboto, Anton, Material Icons) directly in assets to eliminate external font CDN requests and enable full offline PWA rendering.",
      "[Chore] Removed unused legacy turndown dependencies and tuned production bundle budgets.",
      "[Refactor] Removed redundant standalone: true declarations across all 23 components.",
      "[Refactor] Standardized dependency injection on inject() across all services and components.",
      "[Refactor] Removed SSR-era leftovers (isPlatformBrowser and PLATFORM_ID) for pure client PWA execution.",
      "[Chore] Added ESLint integration and configured test:ci and test:rules scripts.",
      "[Docs] Created CLAUDE.md documenting architecture, build/test scripts, Angular conventions, and changelog workflow."
    ],
    "userChanges": [
      "[Feature] Added interactive App Version History dialog accessible by clicking the version number in the lower right corner."
    ]
  },
  {
    "version": "1.1.6",
    "date": "2026-08-18",
    "title": "TCH Mileage Tracker Baseline",
    "changes": [
      "[Feature] Baseline production release of TCH Mileage Tracker PWA with distance calculation, trip logging, and monthly approvals."
    ],
    "userChanges": [
      "[Feature] Mileage logging and monthly reimbursement approvals."
    ]
  }
]
